export default {
    medication: 'دارو',
    medicationTitle: 'عنوان',
    medicationStatus: 'وضعیت',
    medications: 'داروها',
    editMedication: 'ویرایش دارو',
    addMedication: 'داروی جدید',
}